import React from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./StatsCard.css";

const TONE_STYLES = {
  blue: {
    iconBg: "#DBEAFE",
    iconColor: "#2563EB",
  },
  amber: {
    iconBg: "#FEF3C7",
    iconColor: "#F59E0B",
  },
  green: {
    iconBg: "#DCFCE7",
    iconColor: "#22C55E",
  },
  red: {
    iconBg: "#FEE2E2",
    iconColor: "#EF4444",
  },
  purple: {
    iconBg: "#F3E8FF",
    iconColor: "#A855F7",
  },
  cyan: {
    iconBg: "#CFFAFE",
    iconColor: "#06B6D4",
  },
};

export default function StatsCard({
  title,
  value,
  icon,
  tone = "blue",
  trend,
  trendDirection = "down",
  loading = false,
}) {
  const { t } = useTranslation();
  const toneStyle = TONE_STYLES[tone] || TONE_STYLES.blue;
  const Icon = icon;
  const showArrow = trendDirection === "up" || trendDirection === "down";

  return (
    <div className={`stats-card${loading ? " is-loading" : ""}`}>
      {!loading && trend && (
        <div className={`stats-card-trend ${trendDirection}`}>
          {showArrow ? (trendDirection === "down" ? "↓" : "↑") : null}
          {showArrow ? " " : null}
          {trend}
        </div>
      )}

      <div
        className="stats-card-icon"
        style={{
          backgroundColor: toneStyle.iconBg,
          color: toneStyle.iconColor,
        }}
      >
        {Icon ? <Icon sx={{ fontSize: 18 }} /> : null}
      </div>

      <div className="stats-card-content">
        <div className="stats-card-title">{t(title)}</div>
        <div className="stats-card-value">
          {loading ? (
            <CircularProgress size={18} thickness={5} sx={{ color: toneStyle.iconColor }} />
          ) : (
            value
          )}
        </div>
      </div>
    </div>
  );
}
